import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { CustomerStatus, OrganizationType } from '../../customers/types';

export const customersListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'ids',
    label: 'Organization identifier',
    hidden: true,
  },
  {
    name: 'type',
    label: 'Type',
    sortable: false,
  },
  {
    name: 'search',
    label: 'Name',
    sortable: false,
  },
  {
    name: 'dob',
    label: 'Date of Birth',
    sortable: false,
  },
  {
    name: 'countryId',
    label: 'Country',
    sortable: false,
  },
  {
    name: 'phone',
    label: 'Phone',
    sortable: false,
  },
  {
    name: 'email',
    label: 'Email',
    filterModalPlacement: 'right',
    sortable: false,
  },
  {
    name: 'status',
    label: 'Status',
    filterModalPlacement: 'right',
    sortable: false,
  },
];

export const customersListColumnsLabels = {
  firstName: 'First Name',
  lastName: 'Last Name',
  dob: 'Date of Birth',
  countryId: 'Country',
  phone: 'Phone',
  email: 'Email',
  status: 'Status',
  ids: 'Organization identifier',
};

export const customersListSchema = {
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  employmentStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  search: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  countryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  ids: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const customersListFiltersSchema = [
  {
    name: 'type',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'type',
        title: 'Individual customers',
        value: OrganizationType.INDIVIDUAL,
      },
      {
        name: 'type',
        title: 'Company officials',
        value: OrganizationType.COMPANY_OFFICIAL,
      },
    ],
  },
  {
    name: 'ids',
    type: FilterType.TEXT,
    placeholder: 'Enter ID',
  },
  {
    name: 'countryId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country',
  },
  {
    name: 'status',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'status',
        title: 'Active',
        value: CustomerStatus.ACTIVE,
      },
      {
        name: 'status',
        title: 'Closed',
        value: CustomerStatus.CLOSED,
      },
    ],
  },
];
